import React from "react";
import CPSettingToggle from "../../../../UI/Settings/CPSettingToggle";
import CPSettingSize from "../../../../UI/Settings/CPSettingSize";
import CPSettingRange from "../../../../UI/Settings/CPSettingRange";
import CPSettingColor from "../../../../UI/Settings/CPSettingColor";

const MemberPopup = ({ settings, onChange }) => {
    return (
        <>
            <CPSettingToggle
                name="showPopup"
                isChecked={settings?.showPopup}
                label="Показывать поп-ап"
                onChange={onChange}
            />
            {settings?.showPopup && (
                <>
                    <CPSettingRange
                        name="popupBackgroundOpacityPercent"
                        value={settings?.popupBackgroundOpacityPercent}
                        defaultValue={settings?.popupBackgroundOpacityPercent ?? 80}
                        label="Прозрачность фона"
                        step={5}
                        onChange={onChange}
                    />
                    <CPSettingSize
                        name="popupBackgroundBlurSize"
                        eventValue={settings?.popupBackgroundBlurSize}
                        label="Размытие фона"
                        defaultValue="5px"
                        onChange={onChange}
                    />
                    <CPSettingToggle
                        name="showMemberPopupFormat"
                        isChecked={settings?.showMemberPopupFormat}
                        label="Показывать формат"
                        onChange={onChange}
                    />
                    <CPSettingToggle
                        name="showMemberPopupStatus"
                        isChecked={settings?.showMemberPopupStatus}
                        label="Показывать статус"
                        onChange={onChange}
                    />
                    <CPSettingToggle
                        name="showMemberPopupAddToCalendar"
                        isChecked={settings?.showMemberPopupAddToCalendar}
                        label={'Показывать кнопку "Добавить в календарь"'}
                        onChange={onChange}
                    />
                    <CPSettingColor
                        name="popupBackgroundColor"
                        label="Цвет фона модального окна"
                        eventColor={settings?.popupBackgroundColor}
                        defaultColor="#FFFFFF"
                        onChange={onChange}
                    />
                    <CPSettingColor
                        name="popupTextColor"
                        label="Цвет текста модального окна"
                        eventColor={settings?.popupTextColor}
                        defaultColor="#000000"
                        onChange={onChange}
                    />
                </>
            )}
        </>
    );
};

export default MemberPopup;
